<template>
    <div class="stat">        
        <div class="value"><span class="highlight">{{value}}</span><span>{{suffix}}</span>
            <transition appear name="grow" >
                <span class="bar"></span>
            </transition>
        </div>
        <div class="label" :class="[limitWidth ? 'limit-width' : '']" v-html="label"></div>
    </div>
</template>

<script>
export default {
  name: "Stat",  
  data: () => ({}),
  props: { label: String, value:String, suffix:String, limitWidth:Boolean },
};
</script>


<style lang="scss" scoped>
.stat {
    display:inline-block;    
    white-space: nowrap;
    margin-right:40px;
    margin-bottom:15px;
    &:last-child {
        margin-right: 0;
    }
}
.value {
    color: #FFFFFF;
    font-family: 'Gotham';
    font-size: 1.8em;
    font-weight: 900;
    letter-spacing: 0;    
    position: relative;
    display: inline-block;
    margin-bottom: 8px;
    .highlight {
        text-shadow: 0 0 10px rgba(255,255,255,0.34);
    }
    .bar {
        position: absolute;
        bottom:-3px;
        left:0;
        display: inline-block;
        transition: all 0.25s cubic-bezier(1, 0.5, 0.8, 1);
        height: 2px;
        width: 75px;
        background: linear-gradient(90deg, #F5831F 0%, #FFD62F 100%);
        &.grow-enter-to,
        &.grow-enter-active {
            width: 0;
        }
    }
    span {
        font-weight: 300;        
    }
}
.label {    
    color: #FFFFFF;
    font-family: 'Gotham';
    font-size: 0.9em;
    
    letter-spacing: 0;
    white-space: normal;
    &.limit-width {
        width:115px;
    }
}
</style>
